<template>
	<v-container class="ma-0 pa-0" ref="listCard" v-resize="calcTableHeight">
		<v-card elevation="0" style="border-radius: 7px; width: 100%; height: 100%" class="overflow-hidden">
			<v-card-title style="border-bottom: 1px solid #e1dce8; height: 64px">
				<v-row no-gutters>
					<v-col cols="11" class="text-left">
						{{ $t('ccm-records') }}
					</v-col>
					<v-col cols="1">
						<v-icon color="primary" size="25" @click="synchronizeDrawers()"> mdi-plus-circle </v-icon>
					</v-col>
				</v-row>
			</v-card-title>
			<v-data-table
				:items="ccmRecords"
				:headers="headers"
				:items-per-page="-1"
				style="overflow-y: auto"
				:height="dataTableHeight"
				fixed-header
				dense
				sort-by="dateOfService"
				sort-desc
				:loading="dataLoading"
				:footer-props="{ 'items-per-page-text': '' }">
				<template v-slot:item="{ item }">
					<tr :class="getRowsForDataTable(item.id, selectedId === item.id)" @click="updateSelectedRecord(item.id)">
						<td class="text-center px-1">
							{{ item.id }}
						</td>
						<td class="text-center px-1">
							{{ item.providerName }}
						</td>
						<td class="text-center px-1">
							{{
								item.isComplex ? $t('complex') : item.isNonComplex ? $t('non-complex') : $t('physician-npp-provided')
							}}
						</td>
						<td class="text-center px-1">
							{{ formatTimestamp(item.dateOfService, 'date_med') }}
						</td>
						<td class="text-center px-1">
							<v-icon
								v-if="item.canThisCcmRecordBeDeletable"
								size="20"
								:color="selectedId === item.id ? 'white' : 'primary'"
								@click.stop="
									deleteId = item.id;
									showDeleteDialog = true;
								">
								mdi-delete
							</v-icon>
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-card>

		<DeleteDialog
			:dialog.sync="showDeleteDialog"
			@confirm="
				showDeleteDialog = false;
				deleteRecord(deleteId);
				deleteId = -1;
			" />
	</v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { formatTimestamp, getRowsForDataTable } from '@/utils/utilities';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';

export default {
	name: 'CCMRecordsList',
	components: { DeleteDialog },
	data () {
		return {
			selectedId: -1,
			showDeleteDialog: false,
			deleteId: -1,
			dataTableHeight: 200,
		};
	},
	computed: {
		...mapState({
			detailedUser: (state) => state.users.detailedUser,
			ccmRecords: (state) => state.ccmRecords.ccmRecordsByPatientId,
			dataLoading: (state) => state.ccmRecords.ccmRecordLoadingStatus,
			selectedRecord: (state) => state.ccmRecords.ccmRecord,
			patientId: (state) => state.ccmRecords.patientId,
		}),
		...mapGetters({
			pageHeight: 'pageHeight',
		}),
		headers () {
			return [
				{
					text: this.$t('id'),
					sortable: false,
					align: 'center',
					class: 'px-1',
				},
				{
					text: this.$t('provider-name'),
					sortable: false,
					align: 'center',
					class: 'px-1',
				},
				{
					text: this.$t('ccm-type'),
					sortable: false,
					align: 'center',
					class: 'px-1',
				},
				{
					text: this.$t('date-of-service'),
					sortable: false,
					align: 'center',
					class: 'px-1',
				},
				{
					text: '',
					sortable: false,
					align: 'center',
					class: 'px-1',
				},
			];
		},
	},
	methods: {
		...mapActions({
			getSelectedCCMRecordId: 'ccmRecords/getSelectedCCMRecordId',
			deleteCCMRecord: 'ccmRecords/deleteCCMRecord',
			storeCCMRecordsByPatientId: 'ccmRecords/storeMinimalCCMRecordsByPatientId',
		}),
		getRowsForDataTable,
		formatTimestamp,
		synchronizeDrawers () {
			const parameters = {
				detailsDrawer: true,
				page: 'ccmRecords',
			};
			this.$store.commit('SET_DETAILS_DRAWER', parameters);
		},
		async updateSelectedRecord (id) {
			this.selectedId = this.selectedId === id ? -1 : id;
			if (this.selectedRecord !== null && this.selectedRecord.id === id) {
				this.$store.commit('ccmRecords/SET_CCM_RECORD', null);
			} else {
				await this.getSelectedCCMRecordId(id);
			}
		},
		async deleteRecord (id) {
			this.deleteCCMRecord(id);
		},
		calcTableHeight () {
			this.dataTableHeight = this.$refs.listCard.clientHeight - 124;
		},
	},

	mounted () {
		this.$store.commit('ccmRecords/SET_CCM_RECORD', null);
		this.$nextTick(() => {
			this.calcTableHeight();
		});
	},
	watch: {
		async patientId () {
			await this.storeCCMRecordsByPatientId(this.detailedUser.userData.id);
		},
	},
};
</script>
